<template>
  <CommonPageHolder />
</template>
